import React from 'react';
import ProductCard from './ProductCard';
import SearchSkeleton from './SearchSkeleton';

// Denser than the supplier grid — products are compact cards, and we want as
// many above the fold as possible.
const PRODUCT_COLUMN_CLASS = 'is-half-mobile is-one-third-tablet is-one-fifth-desktop';

function ProductResults({ data, isLoading, hasActiveFilters, onClearFilters }) {
  if (isLoading) {
    return <SearchSkeleton count={10} columnClass={PRODUCT_COLUMN_CLASS} />;
  }

  const hasResults = data?.pages?.some((page) => page.products.length > 0);

  if (!hasResults) {
    return (
      <div className="my-6 has-text-centered">
        <p className="mb-2">No products found matching your criteria.</p>
        <p className="has-text-grey mb-4">
          Try adjusting your search terms or filters to find more results.
        </p>
        {hasActiveFilters && (
          <button className="button is-primary is-small" onClick={onClearFilters}>
            Remove all filters
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="columns is-mobile is-multiline">
      {data.pages.map((page, i) => (
        <React.Fragment key={`page-${i}`}>
          {page.products.map((product) => (
            <div key={product.id} className={`column ${PRODUCT_COLUMN_CLASS}`}>
              <ProductCard {...product} />
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}

export default ProductResults;
